<script setup lang="ts">
import { type PropType } from 'vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';

defineProps({
  visible: { type: Boolean, required: true },
  title: { type: String, default: 'Подтвердите действие' },
  message: { type: String, default: '' },
  okText: { type: String, default: 'OK' },
  cancelText: { type: String, default: 'Отмена' },
  okType: { type: String as PropType<'default' | 'danger' | 'normal'>, default: 'default' },
});

const emit = defineEmits<{
  (e: 'update:visible', v: boolean): void;
  (e: 'ok'): void;
  (e: 'cancel'): void;
}>();

function close() { emit('update:visible', false); emit('cancel'); }
function confirm() { emit('ok'); }
</script>

<template>
  <DxPopup
    :visible="visible"
    :title="title"
    :width="420"
    :height="'auto'"
    :show-close-button="true"
    :close-on-outside-click="false"
    @hidden="close"
  >
    <div class="cd-body">{{ message }}</div>

    <DxToolbarItem
      widget="dxButton"
      toolbar="bottom"
      location="after"
      :options="{ text: okText, type: okType, stylingMode: 'contained', onClick: confirm }"
    />
    <DxToolbarItem
      widget="dxButton"
      toolbar="bottom"
      location="after"
      :options="{ text: cancelText, stylingMode: 'outlined', onClick: close }"
    />
  </DxPopup>
</template>

<style scoped>
.cd-body { padding: 8px; font-size: 14px; }
</style>
